import { render, staticRenderFns } from "./companyspecialday.vue?vue&type=template&id=0408d12a&scoped=true&"
import script from "./companyspecialday.vue?vue&type=script&lang=js&"
export * from "./companyspecialday.vue?vue&type=script&lang=js&"
import style0 from "./companyspecialday.vue?vue&type=style&index=0&lang=css&"
import style1 from "./companyspecialday.vue?vue&type=style&index=1&id=0408d12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408d12a",
  null
  
)

export default component.exports